const { getRandomInteger } = require('../../util')

module.exports.getRandomInteger = getRandomInteger // Export this function here too, for uniformity's sake.
